import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormCheck } from 'react-bootstrap';

const FormTableHeading = ({
  allRowsCollapsed = false,
  collapsibleRows = false,
  columns = [],
  form,
  hideInitialColumn = false,
  manager,
  onColumnCheck = () => {},
  onCollapseAll = () => {},
  sortColumn = () => {},
  sortable = true,
}) => {
  const isCheckAllChecked = fieldName => {
    const firstOption = form[fieldName].options[0];
    const checkPage = !!form[fieldName].checkPage;
    const { start, end } = manager;
    const rowIds = manager.getRows();

    if (checkPage) {
      const renderedData = [];
      for (let index = start; index < end; index++) {
        const rowId = rowIds[index];
        const dataIndex = manager.getDataIndexByRowId(rowId);
        if (form[fieldName].data[dataIndex] !== undefined) {
          renderedData.push(form[fieldName].data[dataIndex] === firstOption);
        }
      }
      return renderedData.every(v => v === true);
    }
    return form[fieldName].data.every(v => v === firstOption);
  };

  const hasCheckAll = fieldName => {
    const { count } = manager.getCount();

    if (form[fieldName].control === 'checkbox' && onColumnCheck && !form[fieldName].hideCheckAll && count !== 1) {
      return true;
    }

    return false;
  };

  const headings = [];

  columns.forEach(fieldName => {
    const isHidden = form[fieldName].hidden;
    const isSorted = manager.sortedField === fieldName;
    const isFiltered = manager.filter[fieldName];
    const isCheckbox = form[fieldName].control === 'checkbox';
    const { checkPage, labelAlign } = form[fieldName];

    const control = isHidden ? 'hidden-control' : form[fieldName].control;

    const className = classNames('heading-column', {
      [control]: true,
      'is-hidden': isHidden,
      'is-sorted': isSorted,
      'is-filtered': isFiltered,
      'check-page': checkPage,
      'text-align': labelAlign || 'left',
      sortable,
    });

    const defaultAlign = isCheckbox ? 'center' : 'left';

    const style = {
      textAlign: labelAlign || defaultAlign,
    };

    if (isHidden) {
      headings.push(<td key={fieldName} className={className} />);
      return;
    }

    const showColumnCheck = hasCheckAll(fieldName);
    const label = form[fieldName].label || '';

    headings.push(
      <td key={fieldName} className={className} style={style}>
        {showColumnCheck && (
          <FormCheck
            title={`Check or Uncheck All${checkPage ? ' on page' : ''}`}
            onChange={event => {
              onColumnCheck(event, fieldName);
            }}
            checked={isCheckAllChecked(fieldName)}
            inline
          />
        )}
        <div
          className="heading-label"
          onClick={() => {
            if (sortable) {
              sortColumn(fieldName);
            }
          }}
          title={label}
        >
          {label.replace(/\s/g, '\u00A0').replace(/-/g, '\u2011')}
          {isSorted && (
            <div className="heading-icon sort">
              {manager.sortDirection === 'ASC' && <i className="zmdi zmdi-long-arrow-down" />}
              {manager.sortDirection === 'DESC' && <i className="zmdi zmdi-long-arrow-up" />}
            </div>
          )}
          {isFiltered && (
            <div className="heading-icon filter">
              <i className="zmdi zmdi-filter-list" />
            </div>
          )}
        </div>
      </td>
    );
  });

  return (
    <tr className="heading-row">
      {!hideInitialColumn && (
        <>
          <td width="1" style={{ padding: '0px' }} />
          <td width="1" style={{ textAlign: 'center', padding: '0px' }}>
            {collapsibleRows && (
              <div
                onClick={onCollapseAll}
                className={classNames('collapse-icon', { minus: !allRowsCollapsed })}
                title="Collapse All"
                style={{ marginTop: '5px' }}
              />
            )}
          </td>
          <td width="1" style={{ padding: '0px' }} />
        </>
      )}
      {headings}
    </tr>
  );
};

FormTableHeading.propTypes = {
  allRowsCollapsed: PropTypes.bool,
  collapsibleRows: PropTypes.bool,
  columns: PropTypes.array,
  form: PropTypes.object,
  onColumnCheck: PropTypes.func,
  onCollapseAll: PropTypes.func,
  hideInitialColumn: PropTypes.bool,
  manager: PropTypes.object.isRequired,
  sortColumn: PropTypes.func,
  sortable: PropTypes.bool,
};

export default FormTableHeading;
